import { Children, cloneElement, useContext, useEffect } from 'react';

import { useDepartmentGetQuery } from '../../Common/Queries/departmentQueries';
import { useLevelsGetQuery } from '../../Common/Queries/levelQueries';
import { useSkillsGetQuery } from '../../Common/Queries/skillQueries';
import { useAddStreamQuery } from '../../Common/Queries/streamQueries';
import { useUsersGetQuery } from '../../Common/Queries/usersQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, AuthContext, DURATION_TIME, ROLES } from '../../constants';
/**
 * @function formateData
 * @param values
 * @returns formated values
 */
export const formateData = (values) => {
  return {
    name: values.name,
    department: values.department,
    skills: values.skills,
    levels: values.levels,
    manager: values.manager,
    webHookURL: values.webHookURL,
  };
};

export const initialValues = {
  name: '',
  department: {},
  skills: [],
  levels: [],
  manager: [],
};

export function AddStreamContainer({ setOpen, children }) {
  const postToStream = useAddStreamQuery();

  const { userInfo } = useContext(AuthContext);
  const role = userInfo?.roles?.[0];
  const managerList = useUsersGetQuery(
    {
      limit: ALL_DATA_LIMIT,
      role: [ROLES.ADMIN, ROLES.HIRING_MANAGER, ROLES.SUPER_ADMIN, ROLES.TENANT_OWNER].join(','),
    },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Skills
  const skillList = useSkillsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Departments
  const departmentList = useDepartmentGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Levels
  const levelList = useLevelsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  function handleSubmitForAddStream(e, values) {
    e.preventDefault();
    const reqBody = formateData(values);
    postToStream.mutate(reqBody);
  }

  useEffect(() => {
    if (postToStream.isSuccess) setOpen(false);
  }, [postToStream.isSuccess]);

  return Children.only(
    cloneElement(children, {
      postToStream,
      handleSubmitForAddStream,
      initialValues,
      managerList,
      skillList,
      departmentList,
      levelList,
    })
  );
}
